import React from 'react';
import ModalCustom from '../commonComponents/Modal';
import { useModalControl } from '../commonComponents/Modal/utils';

function withModal(WrappedComponent) {
  return (props) => {
    const { responseMessage, handleModalMessages, resetModalObject } = useModalControl();

    const newProps = {
      handleModalMessages,
      ...props
    };

    return (
      <>
        <WrappedComponent {...newProps} />
        <ModalCustom
          returnFocus={false}
          modalTitle={responseMessage.title}
          modalBody={responseMessage.message}
          showPrimaryButton
          funcPrimaryButton={responseMessage.primaryBttnAction}
          textPrimaryButton={responseMessage.primaryBttnText}
          showSecondaryButton={responseMessage.showSecondaryBttn}
          textSecondaryButton={responseMessage.secondaryBttnText}
          openByDefault={(responseMessage.title.length > 0 && responseMessage.message.length > 0)}
          resetAction={resetModalObject}
        />
      </>
    );
  };
}

export default withModal;
